<template>
  <main>
    <div id="main_post">
      <transition tag="article"  name="slide-up" mode="out-in" v-if="selectedPost">
        <article  :key="selectedPost.id" >
          <header>
            <h1 v-html="selectedPost.title.rendered"></h1>
            <span v-ornament></span>
          </header>
          <div><p v-html="selectedPost.content.rendered"></p></div>
          <span v-ornament></span>
          <p class="author"><button @click="toTop()">Voltar ao topo &uarr;</button> <strong>{{selectedPost.author_meta[0]}} &ndash; {{selectedPost.date | shortDate}}</strong></p>
        </article>
      </transition>
    </div>
  </main>
</template>

<script>
import Axios from 'axios';
export default {
  props: ['type'],
  computed: {
    selectedPost(){
      return this.$store.getters.getPostsSelected;
    }
  },
  watch: {
    '$route': {
      handler() {
        let type;
        if(this.type == 'random') {
          type = false;
          return;
        }
        else {
          type = this.type;
        }
        this.$store.dispatch('selectPostBySlug',[this.$route.params.slug,type])
      }
    }
  },
  mounted() {
    this.$store.dispatch('selectPostBySlug',[this.$route.params.slug])
  },
  filters: {
    shortDate(str) {
      return str.substring(0, 10).split('-').reverse().join('/');
    }
  },
  methods: {
    toTop() {
      let currentYOffset = self.pageYOffset;
      let initYOffset = currentYOffset;

      let intervalId = setInterval(function(){
        currentYOffset -= (document.body.scrollTop + currentYOffset)/10;
        document.body.scrollTop = currentYOffset ;
        document.documentElement.scrollTop = currentYOffset;
        if(self.pageYOffset == 0){
          clearInterval(intervalId);
        }
      }, 10);

    }
  }
}
</script>

<style scoped>
main {
  max-width: 670px;
  margin: auto;
}
article {
  margin: 5em auto;
}
article>div {
  display: flex;
  width: auto;
  flex-wrap: wrap;
  align-items: start;
  padding: 0 2em
}
article>img {
  width: 100%;
}
h1 {
  font-weight: bold;
  font-size: 3em;
  line-height: 40px;
  text-align: center;
  padding: 10px 0;
  text-transform: uppercase
}
.author {
  text-align: right;
  color: rgb(var(--yellow));
  font-size: 1.5em;
  margin:0;
}
.author button {
  float: left;
  background: rgb(var(--yellow));
  border: 0;
  margin-top: -2px;
  padding: 3px 10px;
  font-family:  'DIN Next Slab Pro';
  color: rgb(var(--lgray));
  display: none;
}
small {
  color: #a1a1a1;
  margin: auto
}
nav {
  display: flex
}
a {
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 700px) {
  article>div {
    padding: 0
  }
  article {
    margin: 0 auto;
  }
  article.poesia p {
    text-indent: -2em;
    margin-left: 2em;
  }
  .author button {
    display: block;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Post.vue